/* ★ SEMAKAN PROMPT SEBELUM RUN FLOW (keputusan user 2026-09-18).
 *
 * Robot Flow TIDAK berhenti bila prompt sesuatu set kosong: ia menggantikannya dengan NAMA PRODUK
 * dan terus menjana — gambar + video yang tidak menjadi, kredit Flow terbakar, dan tiada sebab
 * ditulis pada card (kes sebenar: card Tadabbur set 1 pada 16 Sept; card MASAKI dengan Image Prompt
 * kosong pada 15 Sept). Webapp kini menyemak DAHULU, sebelum Flow dibuka. Satu card bermasalah =
 * TIADA automation dijalankan (keputusan user — sama seperti semakan ruang gambar tab My Agent).
 *
 * ⚠️ KEMBAR dengan skrip Flow REMOTE. Peraturan di bawah = medan yang robot BENAR-BENAR baca. Ubah
 *    skrip = ubah fail ini — kalau tidak, semakan ini menahan larian yang sebenarnya OK, atau
 *    melepaskan larian yang akan membakar kredit:
 *    · ai8saat / goyang (Generate di Flow) — flow-automation-v3.js + flow-automation-goyang-v3.js:
 *      `imagePrompt` / `videoPrompt` jatuh ke product.name bila `promptImage` / `promptVideo` kosong.
 *    · ai8saat Workflow "Guna gambar card" — `_jalankanWorkflowKad`: set tanpa `promptVideo` dilangkau.
 *      Image Prompt tidak dipakai langsung dalam workflow ini → tidak disemak.
 *    · ai16saat (AI16SAAT · Home Niche · SMART 2 babak) — gambar `promptImage`; babak 1 `promptVideo`
 *      ATAU `promptVideo1`. Babak 2 (`promptVideo2`) PILIHAN dalam skrip (kosong = video satu babak,
 *      bukan kegagalan) → sengaja TIDAK disemak.
 *    · nscene (FLOWNITY) / dinamik — `prompts.set1` (atau set pertama yang dihantar); babak s =
 *      `promptVideo{s}` (babak 1 jatuh ke `promptVideo`); kosong = babak dilangkau SENYAP. Bilangan
 *      babak dikepit SAMA seperti skrip: nscene 1-8 (lalai 5), dinamik 1-5 (lalai 1). FLOWNITY: hanya
 *      babak yang ditanda di Control Panel disemak — babak yang pelanggan buang tick tidak dikira,
 *      walaupun skrip hari ini masih mencubanya (pilihan babak dalam skrip belum dibina).
 *
 *    · resipi (enjin RESIPI, 17 Okt — PLAN_FLOW_RESIPI.md) — SET PERTAMA yang dihantar sahaja (3+ scene = satu set
 *      per card): `promptImage` WAJIB + Video Prompt SETIAP scene (scene 1 `promptVideo` / `promptVideo1`). Robot
 *      menolak set yang kurang satu pun (bukan dilangkau) → semakan ini mesti sama ketat. Peraturan medan dikongsi
 *      card + popup melalui utils/resipiScene.js (KEMBAR skrip flow-resipi/20-resipi.js).
 *
 * TULEN — tiada React, tiada Firestore (satu import tulen: resipiScene.js). Pemanggil memberi kunci skrip + bilangan babak
 * (getEffectiveScriptKey / getSceneCount) dan card yang SUDAH membawa teks (withDetail selepas hydrate).
 * Ayat paparan dibina di sini melalui `T` pemanggil supaya chip card + popup berkongsi SATU ayat.
 */

import { kurangResipi, setDijalankanResipi, bilBabakResipi, RESIPI_SET_TUNGGAL_DARI } from './resipiScene.js';

const adaTeks = (v) => typeof v === 'string' && v.trim() !== '';

/**
 * Apa yang kurang pada satu card untuk larian Flow ini.
 * @param kad     card dengan teks penuh (`prompts`)
 * @param opsyen  { scriptKey, sets, workflowKad, sceneCount, scenes, setsSiap, jenisGambar }
 *                · jenisGambar — resipi: 'sama' | 'berlainan' (setiap scene perlukan Image Prompt sendiri) | 'tiada' (text to video) | 'sahaja' (Images only) | 'frame' (Before and after)
 *                · sets      — set yang dipilih di Control Panel ('set1'...)
 *                · scenes    — babak FLOWNITY yang ditanda (nombor), null = semua
 *                · setsSiap  — set yang dilangkau skrip (Continue Collection: sudah dihantar)
 * @returns [] bila tiada masalah, atau senarai [{ set: 'set1', kurang: [...] }] / [{ babak: 4, kurang: [...] }]
 *          `kurang` ⊂ ['gambar', 'video'].
 */
export function masalahPromptKad(kad, opsyen = {}) {
    const { scriptKey = 'ai8saat', sets = [], workflowKad = false, sceneCount, scenes = null, setsSiap = [], jenisGambar = 'sama' } = opsyen || {};
    const prompts = (kad && kad.prompts && typeof kad.prompts === 'object') ? kad.prompts : {};
    const objekSet = (k) => (prompts[k] && typeof prompts[k] === 'object') ? prompts[k] : null;
    const setDisusun = (Array.isArray(sets) ? sets : []).filter((s) => typeof s === 'string' && s).slice().sort();

    if (scriptKey === 'nscene' || scriptKey === 'dinamik') {
        const n = scriptKey === 'nscene'
            ? Math.max(1, Math.min(8, Number(sceneCount) || 5))
            : Math.max(1, Math.min(5, Number(sceneCount) || 1));
        const sumber = objekSet('set1') || objekSet(setDisusun[0] || 'set1') || {};
        const dipilih = (scriptKey === 'nscene' && Array.isArray(scenes) && scenes.length)
            ? new Set(scenes.map(Number))
            : null;
        const masalah = [];
        for (let s = 1; s <= n; s++) {
            if (dipilih && !dipilih.has(s)) continue;
            const mentah = sumber['promptVideo' + s] || (s === 1 ? sumber.promptVideo : '') || '';
            if (!String(mentah).trim()) masalah.push({ babak: s, kurang: ['video'] });
        }
        return masalah;
    }

    const siap = new Set(Array.isArray(setsSiap) ? setsSiap : []);

    // ★ Enjin RESIPI — Image Prompt + setiap scene (robot menolak set yang kurang satu pun).
    //   3+ scene: set pertama sahaja, scene kosong dilapor ikut nombor scene. 1–2 scene: SETIAP set dipilih,
    //   dilapor ikut set (bentuk chip sama seperti AI8SAAT / AI16SAAT).
    if (scriptKey === 'resipi') {
        const dijalankan = setDijalankanResipi(setDisusun, sceneCount, [...siap], jenisGambar);
        if (!dijalankan.length) return [];
        if (jenisGambar === 'sahaja' || bilBabakResipi(sceneCount) >= RESIPI_SET_TUNGGAL_DARI) {
            const s = dijalankan[0];
            const k = kurangResipi(objekSet(s), sceneCount, jenisGambar);
            if (jenisGambar === 'berlainan' || jenisGambar === 'sahaja') {
                const babak = [...new Set([...k.gambarKosong, ...k.babakKosong])].sort((a, b) => a - b);
                return babak.map((b) => ({
                    babak: b,
                    kurang: [...(k.gambarKosong.includes(b) ? ['gambar'] : []), ...(k.babakKosong.includes(b) ? ['video'] : [])],
                }));
            }
            return [
                ...(k.gambar ? [{ set: s, kurang: ['gambar'] }] : []),
                ...k.babakKosong.map((b) => ({ babak: b, kurang: ['video'] })),
            ];
        }
        const hasil = [];
        for (const s of dijalankan) {
            const k = kurangResipi(objekSet(s), sceneCount, jenisGambar);
            const kurang = [...(k.gambar ? ['gambar'] : []), ...(k.babakKosong.length ? ['video'] : [])];
            if (kurang.length) hasil.push({ set: s, kurang });
        }
        return hasil;
    }

    const masalah = [];
    for (const s of setDisusun) {
        if (siap.has(s)) continue;
        const p = objekSet(s) || {};
        const kurang = [];
        if (scriptKey === 'ai16saat') {
            if (!adaTeks(p.promptImage)) kurang.push('gambar');
            if (!adaTeks(p.promptVideo) && !adaTeks(p.promptVideo1)) kurang.push('video');
        } else if (workflowKad && scriptKey === 'ai8saat') {
            if (!adaTeks(p.promptVideo)) kurang.push('video');
        } else {
            if (!adaTeks(p.promptImage)) kurang.push('gambar');
            if (!adaTeks(p.promptVideo)) kurang.push('video');
        }
        if (kurang.length) masalah.push({ set: s, kurang });
    }
    return masalah;
}

const nomborSet = (s) => String(s).replace(/^set/i, '');

/**
 * Ayat untuk chip card + baris popup, daripada hasil `masalahPromptKad`.
 * `T(kunci, lalai, vars)` = pembalut pemanggil. ⛔ `lalai` WAJIB ayat penuh (rupa lama memakainya
 * bulat-bulat); `vars` untuk kamus v3.9. Nama medan "Image Prompt"/"Video Prompt" = label pada card.
 * @returns { chip: 'Set 1, 3 tiada prompt', baris: 'Set 1: tiada Image Prompt dan Video Prompt · …' }
 */
export function ringkasMasalahPrompt(masalah, T) {
    const t = typeof T === 'function' ? T : (_kunci, lalai) => lalai;
    const senarai = Array.isArray(masalah) ? masalah : [];
    const bagiSet = senarai.filter((m) => m && m.set);
    const bagiBabak = senarai.filter((m) => m && m.babak);
    const apa = (kurang) => {
        const g = kurang.includes('gambar');
        const v = kurang.includes('video');
        if (g && v) return t('ws.flowPrompt.kurangDua', 'Image Prompt dan Video Prompt');
        if (g) return t('ws.flowPrompt.kurangGambar', 'Image Prompt');
        return t('ws.flowPrompt.kurangVideo', 'Video Prompt');
    };
    const baris = [
        ...bagiSet.map((m) => {
            const n = nomborSet(m.set);
            const a = apa(m.kurang || []);
            return t('ws.flowPrompt.barisSet', `Set ${n}: tiada ${a}`, { n, apa: a });
        }),
        ...bagiBabak.map((m) => t('ws.flowPrompt.barisBabak', `Babak ${m.babak}: tiada prompt`, { n: m.babak })),
    ].join(' · ');
    let chip = '';
    if (bagiSet.length) {
        const s = bagiSet.map((m) => nomborSet(m.set)).join(', ');
        chip = t('ws.flowPrompt.chipSet', `Set ${s} tiada prompt`, { senarai: s });
    } else if (bagiBabak.length) {
        const s = bagiBabak.map((m) => m.babak).join(', ');
        chip = t('ws.flowPrompt.chipBabak', `Babak ${s} tiada prompt`, { senarai: s });
    }
    return { chip, baris, babakSahaja: bagiSet.length === 0 && bagiBabak.length > 0 };
}
